import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const API = process.env.REACT_APP_BACKEND_URL || '';
const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const check = useCallback(async () => {
    try {
      const stored = localStorage.getItem("auth_token");
      const headers = stored ? { Authorization: `Bearer ${stored}` } : {};
      const r = await fetch(`${API}/api/auth/me`, { credentials: "include", headers });
      if (r.ok) setUser(await r.json());
      else { setUser(null); localStorage.removeItem("auth_token"); }
    } catch (_e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = async (email, password) => {
    const r = await fetch(`${API}/api/auth/login`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });
    if (!r.ok) {
      const e = await r.json().catch(() => ({}));
      throw new Error(e.detail || "Login failed");
    }
    const d = await r.json();
    if (d.token) localStorage.setItem("auth_token", d.token);
    setUser({ email: d.email, role: d.role });
    return d;
  };

  const logout = async () => {
    try { await fetch(`${API}/api/auth/logout`, { method: "POST", credentials: "include" }); } catch (_e) {}
    localStorage.removeItem("auth_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isAuthenticated: !!user, refresh: check }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
